import { render } from "./UsersBody.vue?vue&type=template&id=40dfced5&scoped=true"
import script from "./UsersBody.vue?vue&type=script&lang=js"
export * from "./UsersBody.vue?vue&type=script&lang=js"

import "./UsersBody.vue?vue&type=style&index=0&id=40dfced5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dfced5"]])

export default __exports__